import PositioningDeviceInfoAisleModal from './positioning-device-info-aisle-modal.vue'
export default PositioningDeviceInfoAisleModal
